import { Pipe, PipeTransform } from '@angular/core';
import { MarkdownRenderer } from '../renderers/markdown.renderer';

@Pipe({
  name: 'render_markdown',
  standalone: false,
})
export class MarkdownPipe implements PipeTransform {
  constructor(private readonly markdownRenderer: MarkdownRenderer) {
  }

  public static setOptions(): void {

  }

  public async transform(content: string, options?: any): Promise<string> {
    return this.markdownRenderer.render(content);
  }
}